import { trpc } from '@/data-loaders';

export const useSchoolList = (year: number) => {
  return trpc.schoolUnit.getSchoolList.useQuery(
    { year },
    {
      retry: false,
      cacheTime: 1000 * 60 * 60 * 24, // 1 day
      enabled: !!year,
    },
  );
};
